import { render, staticRenderFns } from "./UnitAssignmentSelectionModal.vue?vue&type=template&id=085ebdf8&scoped=true&"
import script from "./UnitAssignmentSelectionModal.vue?vue&type=script&lang=js&"
export * from "./UnitAssignmentSelectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ebdf8",
  null
  
)

export default component.exports